<template>
  <a-card size="small" title="版本分布图" class="p-0">
    <div class="area-chart">
      <e-chart
        style="width: 100%; height: 100%;"
        :options="options"
        autoresize
        dom-id="opensource-version-chart" />
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'VersionChart',
  props: {
    data: Object,
  },
  computed: {
    options () {
      const { versions = {}, versions_active = {} } = this.data
      const xAxisDatas = []

      Object.keys(versions).forEach(key => {
        if (!xAxisDatas.some(item => item.name === key)) {
          xAxisDatas.push({ name: key, value: versions[key] })
        }
      })
      Object.keys(versions_active).forEach(key => {
        if (!xAxisDatas.some(item => item.name === key)) {
          xAxisDatas.push({ name: key, value: versions_active[key] })
        }
      })
      xAxisDatas.sort((a, b) => b.value - a.value)
      return {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '1%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        legend: {
          data: ['Version', 'Version active'],
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisDatas.map(item => item.name),
            axisPointer: {
              type: 'shadow',
            },
            axisLabel: {
              rotate: 45,
              interval: 0,
              formatter: (val) => {
                return this.getName(val)
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: 'Version',
            type: 'bar',
            data: xAxisDatas.map(item => versions[item.name] || 0),
          },
          {
            name: 'Version active',
            type: 'bar',
            data: xAxisDatas.map(item => versions_active[item.name] || 0),
          },
        ],
      }
    },
  },
  methods: {
    getName (name) {
      return name.length > 15 ? name.slice(0, 15) + '...' : name
    },
  },
}
</script>

<style lang="less" scoped>
.area-chart {
  height: 350px;
  ::v-deep {
    .echarts {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
